import { Component, Input, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { TripPackageLangContentBaseClass } from '../../lang-cont-base.class';
import { DatasetRecordService } from 'app/main/components/dataset/services/dataset-record.service';
import { DatasetActionContainerService, DatasetEvents } from 'app/main/components/dataset/services/dataset-action-container.service';
import { DatasetNavigatorService } from 'app/main/components/dataset/services/dataset-navigator.service';
import { DatasetService } from 'app/main/components/dataset/services/dataset.service';
import { AppService } from 'app/services/app.service';
import { DatasetMultilanguageContainerService } from 'app/main/components/dataset/services/dataset-multilanguage-container.service';
import { StepService } from 'app/main/components/dataset/services/step-state.service';

@Component({
    selector: 'product-media',
    templateUrl: './step.component.html',
    styleUrls: ['./step.component.scss'],
    providers: [
        DatasetActionContainerService,
        DatasetRecordService,
        DatasetMultilanguageContainerService
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ProductMediaComponent extends TripPackageLangContentBaseClass implements OnInit{

	carouselBlockConfigs: any;

	constructor(
		public appService: AppService,
		public datasetRS: DatasetRecordService,
		public datasetACS: DatasetActionContainerService,
		protected datasetNavigatorService: DatasetNavigatorService,
		public datasetService: DatasetService,
		public datasetMCS: DatasetMultilanguageContainerService,
		public stepService: StepService){
		/**
		 * init constructor parent class
		 */
		super(appService, datasetRS, datasetACS, datasetNavigatorService, datasetService, datasetMCS, null, {
			datasetCode: 'trip_resource_language_contents',
			actionCode: 'edit',
			parentForeignKey: 'trip_resource_id',
			parentValueKey: 'products.recordId'
		});
		/**
		 * carousel block configs
		 */
		this.carouselBlockConfigs = {
			datasetCode: 'trip_resource_language_contents_carousel_images',
			parentDatasetCode: 'trip_resource_language_contents',
			parentForeignKey: 'trip_resource_language_content_id'
		};
	}

	ngOnInit(): void {
		super.ngOnInit();

		this.stepService.setStepState({
			dataset_code: 'products',
			form_code: 'product-media',
			record_id: this.parentDatasetRS.recordId,
			status: 1
		});
	}
}
